import type { Phase } from '@alpaca-software/40kdc-data';

/**
 * The five battle phases 40kdc tags abilities with, as a runtime list. Pinned to 40kdc's {@link Phase} union: the
 * `satisfies` clause fails typecheck if this list ever misses a member, and {@link GAME_PHASES_COVERS_PHASE} fails
 * if 40kdc adds a phase this list hasn't been updated to include.
 */
export const GAME_PHASES = [
    'command',
    'movement',
    'shooting',
    'charge',
    'fight',
] as const satisfies readonly Phase[];

// Compile-time-only exhaustiveness proof: `Phase` must be assignable to the `GAME_PHASES` union in both
// directions. If 40kdc ever adds a phase, this alias stops resolving to `true` and the file fails to typecheck.
type _GamePhasesCoverPhase = Phase extends (typeof GAME_PHASES)[number] ? true : never;
const _gamePhasesCoverPhase: _GamePhasesCoverPhase = true;

void _gamePhasesCoverPhase;

export function isGamePhase(value: unknown): value is Phase {
    return typeof value === 'string' && (GAME_PHASES as readonly string[]).includes(value);
}
